const mTheHeaderAcademyDataRequired = {
  mTheHeaderAcademyDataRequired: {
    academy: {
      firstText: 'ATENCIÓN: Debes completar tus datos de academia para el correcto funcionamiento, haz click en el siguiente enlace',
      linkText: 'completar datos.'
    }
  }
}

export default mTheHeaderAcademyDataRequired
